import CreateProductionPlant from './CreateProductionPlant';

export default CreateProductionPlant;
